import type { ReactNode } from 'react';

import { Button } from '@oysterjs/ui/button';

import { AgencySubscriptionFieldsFragment, SubscriptionPlan } from '~/api/graphql';
import {
  RENEWAL_BANNER_SHELL,
  RENEWAL_CALL_URL,
  formatAnnualRenewalDate,
  getAnnualRenewalDate
} from './annual-renewal';

const RenewalCallLink = ({ children }: { children: ReactNode }) => (
  <a
    href={RENEWAL_CALL_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="font-medium text-white underline"
  >
    {children}
  </a>
);

export const AnnualRenewalBanner = ({
  agencyName,
  subscription,
  onReview
}: {
  agencyName: string;
  subscription: AgencySubscriptionFieldsFragment;
  onReview: () => void;
}) => {
  const renewalDate = getAnnualRenewalDate(subscription);
  const isPro = subscription.plan === SubscriptionPlan.Pro;

  return (
    <div className={RENEWAL_BANNER_SHELL}>
      <div className="flex flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div className="max-w-3xl space-y-1 text-sm leading-relaxed text-neutral-200">
          <p className="m-0 font-medium text-neutral-50">
            <strong className="text-white">{agencyName}</strong> renews
            {renewalDate && ' on '}
            {renewalDate && (
              <strong className="text-white">{formatAnnualRenewalDate(renewalDate)}</strong>
            )}{' '}
            for a 12 month term.
          </p>
          <p className="m-0">
            {isPro
              ? 'Review your renewal to add seats or change billing frequency.'
              : 'Review your renewal to add seats, change billing frequency, or upgrade to Cara Pro.'}
          </p>
          {isPro ? (
            <p className="m-0">
              If you’re interested in learning more about broader customization options and
              workflows available with Cara Enterprise,{' '}
              <RenewalCallLink>contact our team</RenewalCallLink>.
            </p>
          ) : (
            <p className="m-0">
              Reach out to <RenewalCallLink>support</RenewalCallLink> for questions.
            </p>
          )}
        </div>
        <Button color="white" onClick={onReview} className="shrink-0 self-start sm:self-center">
          Review renewal
        </Button>
      </div>
    </div>
  );
};
